import { c as _c } from "react/compiler-runtime";
import { faroCoreApiClient } from "@api/faro-core-api-client";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { Button, Link, Text, Tooltip } from "@flat-ui";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useIsStripePurchaseEnabled } from "@hooks/use-credit-packages";
import { QuoteConfirmationDialog } from "@pages/settings/subscription-settings/credits/quote-confirmation-dialog";
import { QuoteSuccessDialog } from "@pages/settings/subscription-settings/credits/quote-success-dialog";
import { SettingsTabs } from "@router/route-params";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { useCompanyId } from "@context-providers/company-id-provider";
import { formatCreditPackagePrice } from "@utils/credit-package-utils";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useCallback, useState } from "react";
/** Renders request quote for credit package */
export function RequestCreditQuote(t0) {
  const $ = _c(23);
  const {
    selectedPackage
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const companyId = useCompanyId();
  const {
    navigateToSettingsPage
  } = useAppNavigation();
  const isStripePurchaseEnabled = useIsStripePurchaseEnabled();
  const [isLoading, setIsLoading] = useState(false);
  const [shouldShowConfirmationDialog, setShouldShowConfirmationDialog] = useState(false);
  const [shouldShowSuccessDialog, setShouldShowSuccessDialog] = useState(false);
  let t1;
  if ($[0] !== companyId || $[1] !== handleErrorWithToast || $[2] !== selectedPackage || $[3] !== trackEvent) {
    t1 = async () => {
      if (!selectedPackage) {
        return;
      }
      setIsLoading(true);
      trackEvent({
        name: WorkspaceEvents.requestQuote,
        props: {
          creditsAmount: selectedPackage.tokenAmount
        }
      });
      ;
      try {
        const customMessage = `Requesting quote for:
          • Package: ${selectedPackage.name}
          • Price: ${formatCreditPackagePrice(selectedPackage.priceInCents)}`;
        await faroCoreApiClient.notification.notificationRequest({
          payload: {
            type: "service_request",
            context: {
              companyId
            },
            data: {
              name: `Requesting to add ${selectedPackage.tokenAmount} ${CREDITS_DISPLAY_NAME}`,
              comment: customMessage
            }
          }
        });
        setShouldShowConfirmationDialog(false);
        setShouldShowSuccessDialog(true);
      } catch (t2) {
        const error = t2;
        handleErrorWithToast({
          id: `sendQuoteRequest-${Date.now().toString()}`,
          title: "Request failed. Please try again.",
          error
        });
      }
    };
    $[0] = companyId;
    $[1] = handleErrorWithToast;
    $[2] = selectedPackage;
    $[3] = trackEvent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleRequestCreditQuote = t1;
  let t2;
  if ($[5] !== companyId || $[6] !== navigateToSettingsPage) {
    t2 = function onConfirmationDialogClose() {
      setShouldShowSuccessDialog(false);
      navigateToSettingsPage({
        companyId,
        settingsTab: SettingsTabs.subscription
      });
    };
    $[5] = companyId;
    $[6] = navigateToSettingsPage;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onConfirmationDialogClose = t2;
  let t3;
  if ($[8] !== isStripePurchaseEnabled || $[9] !== selectedPackage) {
    t3 = !isStripePurchaseEnabled ? <Tooltip component="div" title={!selectedPackage ? "Please select a package to request a quote." : ""}><Button fullWidth={true} disabled={!selectedPackage} onClick={() => setShouldShowConfirmationDialog(!!selectedPackage)}>Request a quote</Button></Tooltip> : <Text variant="bodyM" sx={{
      marginTop: "18px",
      marginX: "auto"
    }}>You may{" "}<Link component="button" onClick={() => setShouldShowConfirmationDialog(!!selectedPackage)}><Tooltip title={!selectedPackage ? "Please select a package to request a quote" : ""}>request a quote</Tooltip></Link>{" "}as an alternative.</Text>;
    $[8] = isStripePurchaseEnabled;
    $[9] = selectedPackage;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== handleRequestCreditQuote || $[12] !== isLoading || $[13] !== selectedPackage || $[14] !== shouldShowConfirmationDialog) {
    t4 = selectedPackage && shouldShowConfirmationDialog && <QuoteConfirmationDialog selectedPackage={selectedPackage} isLoading={isLoading} onConfirm={handleRequestCreditQuote} onClose={() => setShouldShowConfirmationDialog(false)} />;
    $[11] = handleRequestCreditQuote;
    $[12] = isLoading;
    $[13] = selectedPackage;
    $[14] = shouldShowConfirmationDialog;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== onConfirmationDialogClose || $[17] !== shouldShowSuccessDialog) {
    t5 = shouldShowSuccessDialog && <QuoteSuccessDialog onClose={onConfirmationDialogClose} />;
    $[16] = onConfirmationDialogClose;
    $[17] = shouldShowSuccessDialog;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}